import { GameAnswer } from "shared/games/types/GameAnswers";

interface StateGame {
  type: "game";
}

interface StateCorrect {
  type: "correct";
  pointsEarned: number;
}

export function isStateCorrect<A extends GameAnswer>(
  state: State<A>
): state is StateCorrect {
  return state.type === "correct";
}

interface StateIncorrect<A extends GameAnswer> {
  type: "incorrect";
  answer: A;
  pointsEarned: number;
}

export function isStateIncorrect<A extends GameAnswer>(
  state: State<A>
): state is StateIncorrect<A> {
  return state.type === "incorrect";
}

export type State<A extends GameAnswer> =
  | StateGame
  | StateCorrect
  | StateIncorrect<A>;
